

























import { Component, Vue } from 'vue-property-decorator'
import { AddCityClassify,UpdateCityClassify } from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'

@Component({
  components: {VImageUpload},
})
export default class EditCityClassify extends Vue {
  private show = false
  private fromData = {
    id: undefined,
    parentClassifyId: undefined,
    classifyName:undefined,
    classifyDesc:undefined,
    isShow:true,
    imageUrlList:[],
    imageUrlList2:[],
    imageUrl:"",
    imageUrl2:"",
    sort:0,
  }
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    classifyName: [this.requiredRule],
  }

  public open(data:any){
    const d = {...data}
    d.children = undefined
    if(d.imageUrl){
      d.imageUrlList = d.imageUrl.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      d.imageUrlList = []
    }

     if(d.imageUrl2){
      d.imageUrlList2 = d.imageUrl2.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      d.imageUrlList2 = []
    }
    this.fromData = {...this.fromData,...d}
    this.show = true
  }

  public close() {
    this.fromData = {
      id: undefined,
      parentClassifyId: undefined,
      classifyName:undefined,
      classifyDesc:undefined,
      isShow:true,
      imageUrlList:[],
      imageUrl:"",
      imageUrlList2:[],
      imageUrl2:"",
      sort:0,
    }
    this.$emit("close")
    this.show = false
  }

  // 保存
  private save(){
    console.log("保存")

    this.fromData.imageUrl = this.fromData.imageUrlList.map((e: any) => e.url).join(',')
    this.fromData.imageUrl2 = this.fromData.imageUrlList2.map((e: any) => e.url).join(',')

    const f = this.$refs.addForm as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        this.$message.warning("尚有信息有误，请完善")
        return
      }
      const param = {...this.fromData}

      if(param.id){
        UpdateCityClassify(param).then(res=>{
          if(res){
            this.$message.success('修改成功')
            this.$emit("success")
            this.close()
          }
        })
      } else {
        AddCityClassify(param).then(res=>{
          if(res){
            this.$message.success('保存成功')
            this.$emit("success")
            this.close()
          }
        })
      }


    })
  }

}
